// Constants for About formulas

import { isRelease261Enabled } from '@/config/release261Features';
import { isRelease263Enabled } from '@/config/release263Features';

// Source sets definitions
export const CURATED_SOURCES_GDA = [
  'CLINGEN',
  'CLINPGX',
  'CLINVAR',
  'GENCC',
  'MGD HUMAN',
  'RGD ORPHANET',
  'PSYGENET',
  'UNIPROT',
];

export const CURATED_SOURCES_VDA = ['CLINGEN', 'CLINPGX', 'CLINVAR', 'GWASCAT', 'PHEWASCAT', 'UNIPROT'];

export const CLINICAL_TRIALS_SOURCES = ['CLINICAL TRIALS'];

const INFERRED_SOURCES_BASE = ['FINNGEN', 'GWASCAT', 'HPO', 'PHEWASCAT', 'UKBIOBANK'] as const;

export const INFERRED_SOURCES = [
  ...INFERRED_SOURCES_BASE,
  ...(isRelease261Enabled ? (['CHEMBL'] as const) : []),
];

const INFERRED_SOURCE_API_IDS_BASE = [
  'INFERRED',
  'FINNGEN',
  'GWASCAT',
  'HPO',
  'PHEWASCAT',
  'UKBIOBANK',
] as const;

export const INFERRED_SOURCE_API_IDS = [
  ...INFERRED_SOURCE_API_IDS_BASE,
  ...(isRelease261Enabled ? (['CHEMBL'] as const) : []),
];

export const RELATION_EXTRACTION_ASSOCIATION_TYPES_BASE = [
  'Altered Expression',
  'Biomarker',
  'CNV',
  'Causal Mutation',
  'Cell Marker',
  'Epigenomic Alterations',
  'Fusion Gene',
  'Non-coding RNA Regulation',
  'Other',
  'Pharmacogenomics',
  'Post-translational Modification',
  'Protective Mutation',
  'Susceptibility Mutation',
  'Therapeutic Target',
] as const;

export const RELATION_EXTRACTION_ASSOCIATION_TYPES_263 = [
  'Upregulation',
  'Downregulation',
  'Accumulation and Aggregation',
  'Activity',
  'QTL',
] as const;

export const RELATION_EXTRACTION_ASSOCIATION_TYPES = [
  ...RELATION_EXTRACTION_ASSOCIATION_TYPES_BASE,
  ...(isRelease263Enabled ? RELATION_EXTRACTION_ASSOCIATION_TYPES_263 : []),
] as const;

export const RELATION_EXTRACTION_ASSOCIATION_TYPES_GDA = RELATION_EXTRACTION_ASSOCIATION_TYPES;

export const LEGACY_ASSOCIATION_TYPES_GDA = [
  'CausalOrContributing',
  'ChromosomalRearrangement',
  'DrugResponse',
  'GeneticVariation',
  'GermlineCausalMutation',
  'GermlineModifyingMutation',
  'Phosphorylation',
  'SomaticCausalMutation',
] as const;

export const ASSOCIATION_TYPES_GDA_PRE_V261 = [
  'AlteredExpression',
  'Biomarker',
  'CausalMutation',
  'CausalOrContributing',
  'CellMarker',
  'ChromosomalRearrangement',
  'DrugResponse',
  'EpigenomicAlterations',
  'FusionGene',
  'GeneticVariation',
  'GermlineCausalMutation',
  'GermlineModifyingMutation',
  'Pharmacogenomics',
  'Phosphorylation',
  'PostTranslationalModification',
  'SomaticCausalMutation',
  'SusceptibilityMutation',
] as const;

export const ASSOCIATION_TYPES_GDA = isRelease261Enabled
  ? [...RELATION_EXTRACTION_ASSOCIATION_TYPES, ...LEGACY_ASSOCIATION_TYPES_GDA]
  : [...ASSOCIATION_TYPES_GDA_PRE_V261];

export const LEGACY_ASSOCIATION_TYPES_VDA = ['DrugResponse', 'GeneticVariation', 'VUS'] as const;

export const ASSOCIATION_TYPES_VDA_PRE_V261 = [
  'CausalMutation',
  'DrugResponse',
  'GeneticVariation',
  'Pharmacogenomics',
  'SusceptibilityMutation',
  'VUS',
] as const;

export const ASSOCIATION_TYPES_VDA = isRelease261Enabled
  ? [...RELATION_EXTRACTION_ASSOCIATION_TYPES, ...LEGACY_ASSOCIATION_TYPES_VDA]
  : [...ASSOCIATION_TYPES_VDA_PRE_V261];

export const MODELS_SOURCES = ['MGD MOUSE', 'RGD RAT', 'TEXTMINING MODELS'];

export const LITERATURE_SOURCES = ['TEXTMINING HUMAN', 'TEXTMINING MODELS'];

export const LITERATURE_SOURCES_VDA = ['TEXTMINING HUMAN'];

export const BIOBANK_SOURCES = ['FINNGEN', 'UKBIOBANK'];

// Common MathML namespace
export const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
